<section class="container pt-5 pb-lg-5 pb-md-4 pb-2">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-9 col-lg-6 d-flex flex-column align-items-center">

      <img src="assets/images/illustrations/failed-payment.svg" class="w-75 w-md-50 mt-5 pt-lg-3 pb-md-1 pb-3">
      <h1 class="h2 mt-5">Depozit esuat</h1>

      <ng-container *ngIf="deposit">
        <p class="mt-4">Depozitul tau in valoare de
          <strong>{{deposit.amount}} lei</strong> nu a putut fi procesat.
        </p>
        <p>
          Aceasta incercare de plata a fost
          inregistrata cu numarul de referinta
          <strong>{{deposit.id}}</strong> la data
          <strong>{{deposit.createdDate | date: 'dd/MM/yyyy'}}</strong>.
        </p>

        <div class="alert d-flex alert-info w-100" role="alert">
          <i class="ai-circle-info fs-xl pe-1 me-2"></i>
          <div>Valoarea nu a fost retrasa de pe cardul bancar folosit pentru plata!</div>
        </div>
      </ng-container>

      <a [routerLink]="['/user/dashboard']" class="btn btn-lg btn-primary w-100 w-sm-auto mb-3 mb-sm-0 mt-4">Inapoi la Dashboard</a>

    </div>
  </div>
</section>
